import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';

// Подавляем безобидную ошибку "ResizeObserver loop completed with undelivered notifications"
// Она возникает при быстром изменении размеров DOM внутри ResizeObserver-callback
// и не влияет на работу приложения (согласно спецификации).
const RESIZE_OBSERVER_ERR = /ResizeObserver loop/;
window.addEventListener('error', (e) => {
  if (e && e.message && RESIZE_OBSERVER_ERR.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const msg = e && e.reason && (e.reason.message || e.reason.toString());
  if (msg && RESIZE_OBSERVER_ERR.test(msg)) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
